import { DwAmplitudeContext } from '@/providers/dw-amplitude';
import { useContext } from 'react';

export default function useDwAmplitude() {
    return useContext(DwAmplitudeContext);
}
